import React, { FunctionComponent } from 'react';
import ThumbnailOverrideComponent from './ThumbnailOverride';
import Watermark from './Watermark';
import ThreeSixtyViewer from './ThreeSixyViewer';
import AssetBackgroundColor from './AssetBackgroundColor';

import './styles/_advanced.scss';

interface AdvancedSectionProps {
  includeAdvancedOptions: boolean;
}


const AdvancedSection: FunctionComponent<AdvancedSectionProps> = ({ includeAdvancedOptions }) => (
  <div className="asset-advanced">
    <div className="m-asset-advanced-container">
      <ThumbnailOverrideComponent />
      { includeAdvancedOptions
        && (
          <>
            {BFG.hasFeature('watermarking') && <Watermark />}
            <ThreeSixtyViewer />
            <AssetBackgroundColor />
          </>
        )
      }
    </div>
  </div>
);

export default AdvancedSection;
